var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13667",
    "data-name": "Group 13667",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3096",
    "data-name": "Rectangle 3096",
    width: 16,
    height: 16,
    fill: "#868a97"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13666",
    "data-name": "Group 13666",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13040",
    "data-name": "Path 13040",
    d: "M8,0a8,8,0,1,0,8,8A8.009,8.009,0,0,0,8,0M8,14.807A6.808,6.808,0,1,1,14.806,8,6.814,6.814,0,0,1,8,14.807",
    fill: "#868a97"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13041",
    "data-name": "Path 13041",
    d: "M7.576,12.046l4.039-2.421a.379.379,0,0,0,0-.651L7.576,6.554A.38.38,0,0,0,7,6.879V11.72a.379.379,0,0,0,.378.38.39.39,0,0,0,.2-.054",
    transform: "translate(-0.6 -1.3)",
    fill: "#868a97"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPlay);
export default __webpack_public_path__ + "static/media/videoPlay.cebe8729b98f0811d9c40a617dc152b9.svg";
export { ForwardRef as ReactComponent };